import * as actions from '../constants/actionTypes';

export const INITIAL_STATE = {
  email: '',
  password: '',
  authUser: localStorage.getItem('userToken'),
  error: false,
  errorMessage: '',
  errorCode: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.LOGIN_CLEAR_ERROR:
      return {
        ...state,
        error: false,
        errorMessage: '',
        errorCode: '',
      };

    case actions.LOGIN_REQUEST_SUCCESS:
      return {
        ...state,
        authUser: action.payload,
        logout: false,
        username: '',
        password: '',
        error: false,
        errorMessage: '',
        errorCode: '',
      };

    case actions.LOGIN_FAIL:
      return {
        ...state,
        error: true,
        errorMessage:
          (action.payload && action.payload.message) || 'Incorrect email or password',
        errorCode: (action.payload && action.payload.code) || '',
      };

    case actions.LOGOUT_REQUEST_SUCCESS:
      return {
        authUser: null,
        logout: true,
        username: '',
        password: '',
      };

    default:
      return state;
  }
};
